import useSWR from 'swr';
import { InventoryThreshold } from '@/lib/shopifyAdmin';

interface UseInventoryThresholdProps {
  productId: string | undefined;
  threshold?: number;
  skip?: boolean;
}

async function fetchInventoryData(url: string) {
  const response = await fetch(url);
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Failed to fetch inventory data');
  }

  return data.inventoryData;
}

export function useInventoryThreshold({
  productId,
  threshold,
  skip = false,
}: UseInventoryThresholdProps) {
  const params = new URLSearchParams();
  if (productId) params.append('productId', productId);
  if (threshold) params.append('threshold', threshold.toString());

  const {
    data: inventoryData,
    isLoading,
    error,
  } = useSWR<InventoryThreshold[]>(
    !skip && productId && threshold ? `/api/inventory?${params}` : null,
    fetchInventoryData,
    {
      revalidateOnFocus: false,
      dedupingInterval: 5 * 60 * 1000, // Dedupe requests for 5 minutes
    },
  );

  return {
    inventoryData,
    isLoading,
    error,
  };
}
